module.exports = __webpack_public_path__ + "static/media/Version.f5e11a7e.txt";


//////////////////
// WEBPACK FOOTER
// ./src/Version.txt
// module id = 126
// module chunks = 1